module.exports = __webpack_public_path__ + "static/media/md-star.c2138895.svg";